import React from 'react';
import { useTranslations } from '../../../locales/useTranslations';
import { BiCheckShield, BiLock, BiGlobe, BiKey, BiHide, BiFile } from 'react-icons/bi';

const ZeroTrustVpnTrust = () => {
  const { t } = useTranslations();
  const points = [
    { icon: BiFile, text: t('managedServices_zeroTrustVpn_trust_point1') },
    { icon: BiKey, text: t('managedServices_zeroTrustVpn_trust_point2') },
    { icon: BiLock, text: t('managedServices_zeroTrustVpn_trust_point3') },
    { icon: BiHide, text: t('managedServices_zeroTrustVpn_trust_point4') },
    { icon: BiGlobe, text: t('managedServices_zeroTrustVpn_trust_point5') },
    { icon: BiCheckShield, text: t('managedServices_zeroTrustVpn_trust_point6') },
  ];

  return (
    <section className="ms-section ms-section--trust">
      <div className="container">
        <div className="ms-section-header ms-section-header--center">
          <span className="ms-section__badge">{t('managedServices_zeroTrustVpn_trust_badge')}</span>
          <h2 className="ms-section__title">{t('managedServices_zeroTrustVpn_trust_title')}</h2>
          <p className="ms-section__lead ms-section__lead--center">
            {t('managedServices_zeroTrustVpn_trust_text')}
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="ms-trust-grid">
              {points.map((point, index) => {
                const Icon = point.icon;
                return (
                  <div key={index} className="ms-trust-grid__item">
                    <span className="ms-trust-grid__icon" aria-hidden>
                      <Icon />
                    </span>
                    <p>{point.text}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ZeroTrustVpnTrust;
